import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';
import { FormControl, FormHelperText } from "../widget";
import { RxFormField } from "../../rx-form";
import { isDefined } from "../../utils";
import FileUploader, { FileUploaderState } from "../file-uploader/FileUploader";


export interface FileUploadProps extends RxFormField
{
    autoFocus?: boolean;
    fullWidth?: boolean;
    uploadFileUrl: string;
    maxFiles: number;
    allowedExtensions: string[];
}

type PropsType = FileUploadProps & WithStyles<typeof styles>;

class FileUpload extends React.PureComponent<PropsType> {

    constructor(props: PropsType)
    {
        super(props);
        const { ...field } = this.props;
    }

    uploaderStateChanged = (state: FileUploaderState) =>
    {
        this.props.setValue(state.files.concat([]));
    }

    render()
    {

        const { classes, uploadFileUrl, maxFiles, allowedExtensions, fullWidth, autoFocus, ...field } = this.props;
        const helperTextId = (field.note || field.error) ? `${field.id}-text` : undefined;
        const hasError = field.touched && isDefined(field.error);
        const helperText = hasError ? field.error : field.note;

        return <FormControl fullWidth={fullWidth} error={hasError} aria-describedby={helperTextId}>
            <FileUploader id={field.id} uploadFileUrl={uploadFileUrl} maxFiles={maxFiles} uploadedFiles={field.value || []} stateChanged={this.uploaderStateChanged} allowedExtensions={allowedExtensions} />
            {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
        </FormControl>;
    }
}

const styles = (theme: Theme) => createStyles({
});


export default withStyles(styles)(FileUpload);
